import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import Alert from '../../components/alert';
import { requestPasswordReset } from '../../common/services/auth';
import './styles/forget-password.css';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';

function ForgetPassword() {
  useEffect(() => {
    document.title = 'Forgot Password - Cheda Gaming';
  }, []);

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const navigate = useNavigate();
  // const authInstance = getAuth();

  const showAlert = (type, message, title = null) => {
    setAlert({ type, message, title });
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!email) {
      showAlert('error', 'Please enter your email address', 'Missing Email');
      return;
    }

    setLoading(true);

    try {
      const response = await requestPasswordReset({ email });
      showAlert('success', 'An OTP has been sent to your email. Please enter it to reset your password.', 'OTP Sent');
      // Redirect to Verify OTP screen with source = forgot-password
      navigate('/verify-otp', { state: { from: 'forgot-password', email, otp: response.otp } });
    } catch (error: any) {
      showAlert('error', error?.message || 'Error requesting password reset', 'Reset Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forget-password-page page-with-navbar-footer">
      {/* Navbar */}
      <Navbar />

      {/* Gaming Background */}
      <div className="forget-password-background">
        <div className="background-overlay"></div>
      </div>

      {/* Main Content */}
      <div className="forget-password-container">
        <div className="forget-password-card">
          {/* Logo Section */}
          <div className="forget-password-header">
            <div className="logo-container">
              <img 
                src="/images/chedagaming_logo.png" 
                alt="Cheda Gaming" 
                className="forget-password-logo"
              />
            </div>
            <h1 className="forget-password-title">Reset Your Password</h1>
            <p className="forget-password-subtitle">
              Enter your email address and we'll send you a link to reset your password
            </p>
          </div>

          {/* Reset Password Form */}
          <form onSubmit={handleResetPassword} className="forget-password-form">
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <div className="input-container">
                <Mail className="input-icon" size={20} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  disabled={loading}
                  className="form-input"
                />
              </div>
            </div>

            <button 
              type="submit" 
              className="reset-button"
              disabled={loading}
            >
              {loading ? 'Sending Email...' : 'Send Reset Link'}
            </button>
          </form>

          {/* Back to Login Link */}
          <div className="back-to-login-section">
            <p className="back-to-login-text">
              Remember your password?{' '}
              <Link to="/login" className="back-to-login-link">
                Back to Login
              </Link>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />

      {/* Alert Component */}
      {alert && (
        <Alert
          type={alert.type}
          title={alert.title}
          message={alert.message}
          onClose={hideAlert}
          duration={5000}
          position="top-right"
        />
      )}
    </div>
  );
}

export default ForgetPassword; 